// Player Cards — per-player booking odds table (Phase 3 → M2 wave 9). Identical to
// Player Goals but for the player-cards dataset + the `pc-wrapper` class; thin
// wrapper over <PlayerMarketTable>. Market type is Anytime / First.
//
// The player-cards dataset now comes from app-api via `useWidgetData` (was the
// `getPlayerCardsMarketData` legacyData getter); the controls reshape the fetched
// payload client-side (no refetch).

import { shapePlayerTable } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import PlayerMarketTable from "./PlayerMarketTable.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface PlayerCardsProps {
  fixture: string;
  bookmaker?: string | null;
  scope?: string | null;
  /** Market type: "Anytime" | "First"; defaults to "Anytime". */
  marketType?: string | null;
}

export default function PlayerCards({
  fixture,
  bookmaker,
  scope,
  marketType,
}: PlayerCardsProps) {
  const { data, isPending, isError, refetch } = useWidgetData(
    "player-cards",
    useFixtureKey(fixture)
  );
  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const rows =
    shapePlayerTable(
      data ?? {},
      fixture || "Arsenal v Everton",
      scope || "Match",
      bookmaker || "Pinnacle",
      marketType || "Anytime"
    ) ?? [];
  return <PlayerMarketTable wrapperClass="pc-wrapper" rows={rows} />;
}
